import type { LogFileListScope } from '../types/LogBrowseTypes';
import { TAB_HEADER_GRADIENT_BG } from '../../shared/ui';

export const logBrowseSelectClass =
    'w-full min-w-0 appearance-none rounded-md border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-2 pr-9 text-sm text-gray-900 dark:text-slate-100 focus:border-blue-500 dark:focus:border-blue-400 focus:outline-none focus:ring-1 focus:ring-blue-500/20 dark:focus:ring-blue-500/30 disabled:cursor-not-allowed disabled:bg-gray-50 dark:disabled:bg-slate-800 disabled:text-gray-500 dark:disabled:text-slate-500';

/** Expandable panel (Filters / File viewer): details + summary row. */
export const logBrowsePanelDetailsClass =
    'group rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-sm overflow-hidden';

export const logBrowsePanelSummaryClass =
    `flex cursor-pointer list-none items-start gap-3 border-b border-slate-300 dark:border-slate-700 px-4 py-3 [&::-webkit-details-marker]:hidden ${TAB_HEADER_GRADIENT_BG}`;

/** Max rows shown in the log file viewer list (page scrolls; list does not grow unbounded). */
export const LOG_FILES_PANE_MAX_VISIBLE = 5;

export function modeLabelForScope(scope: LogFileListScope): string {
    switch (scope) {
        case 'by_folder':
            return 'One folder';
        case 'by_event':
            return 'All files for event';
        case 'fleet_wide':
            return 'Fleet-wide';
        case 'no_folder':
            return 'No folder';
        default:
            return scope;
    }
}
